export const AMENITIES = {
  WIFI: 'WIFI',
  TV: 'TV',
  ETICKET: 'ETICKET',
  WC: 'WC',
  AC: 'AC',
  CHAIR: 'CHAIR',
  PLUG: 'PLUG',
  LIGHT: 'LIGHT',
  EXCURSION_TRIP: 'EXCURSION',
  LUNCHBOX: 'LUNCHBOX',
  GUIDE: 'GUIDE'
}
